export default {
      id: "exit-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#exit",
      toString: function () {
        return this.url;
      }
    }